let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // Isolate each subscriber: if one throws (e.g. a section that isn't present
      // on the current page), it must not stop the other subscribers from running,
      // and it must not break whatever code called publish() in the first place
      // (e.g. product-form.js still needs to open/render the cart drawer).
      try {
        callback(data);
      } catch (e) {
        console.error(e);
      }
    });
  }
}
